/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useState, type FC, useEffect } from 'react'
import Grid from '@mui/material/Grid'
import { viewGatewayService } from '../../services/viewGatewayService'
import HierarchyView from '../ViewGateway/HierarchyView'
import LanguageStrings from '../../../../i18n/locales'
import './ViewGateway.css'
import { Button } from '../../../../components/Button'

interface ViwGateway {
  loading: boolean
  ViewGateway: any
  errorMsg: boolean
}

const ViewGatewayStrings = LanguageStrings().GatewayManagementCollectionStrings.ViewGateway

const ViewGateway: FC<any> = (props) => {
  const [gatewayView, setgatewayView] = useState<ViwGateway>({
    loading: false,
    ViewGateway: {},
    errorMsg: false
  })

  useEffect(() => {
    viewGatewayData()
  }, [props.gatewayId])

  const viewGatewayData = (): any => {
    viewGatewayService.viewGateway(props.gatewayId, props.assetId)
      .then((res: any) => {
        setgatewayView({ ...gatewayView, ViewGateway: res.data.data })
      })
      .catch(
        (res: any) => {
        }
      )
  }

  const { ViewGateway } = gatewayView

  return (
    <Grid container className="view_gateway_popup" style={{ width: '45%' }} alignContent="flex-start">
      <Grid item xs={12} className='gateway_information'>
        <p>{ViewGatewayStrings.HierarchyView}</p>
      </Grid>
      <HierarchyView site={ViewGateway?.hierarchyStructure?.site} id={props.gatewayId} />
        <Grid item xs={12} style={{ display: 'flex', justifyContent: 'end', bottom: '15px', right: '10px', position: 'absolute' }}>
            <Button type='hollow' className='view-close-btn' dataTestId="close-btn-click" onClick={() => { props.viewGatewayPopup('') }}>
                {'Close'}
            </Button>
        </Grid>
    </Grid>
  )
}

export default ViewGateway
